import { createLazyComponent } from '@muse-web/router'

import { ToasterPlaceholder } from './ToasterPlaceholder'
import type { TToasterProps } from './Toaster.types'

export const AsyncToaster = createLazyComponent<TToasterProps, 'SonnerToaster'>(
    () => import(/* webpackChunkName: 'sonner' */ './SonnerToaster'),
    'SonnerToaster',
    { fallback: ToasterPlaceholder },
)
